document.addEventListener("DOMContentLoaded", function () {
    const  languageLinks = document.querySelectorAll('.language-link');

    const addAriaLabel = () => {
        languageLinks.forEach(link => {
            switch (link.getAttribute('hreflang')) {
                case 'fr':
                    link.setAttribute('aria-label', 'Voir la page en français');
                    break;
                case 'en':
                    link.setAttribute('aria-label', 'View the page in English');
                    break;
            }
        });
    }

    const addAriaCurrent = () => {
        languageLinks.forEach(link => {
            if (link.classList.contains('is-active')) {
                link.setAttribute('aria-current', 'true');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    }

    addAriaLabel();
    addAriaCurrent();
});